import { useMutation } from "@apollo/client";
import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";

import QUERY from "../../utils/service/query";
import ActionFileUpload from "./ActionFileUpload";

interface PropsType {
  userId: string;
  status: string;
}

const ActionForm: React.FC<PropsType> = ({ userId, status }) => {
  const [updateStatus] = useMutation(QUERY.USERS.STATUS_ACTION);
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState("");
  const [reason, setReason] = useState("");
  const [files, setFiles] = useState<any>([]);
  const [filesUrl, setFilesUrl] = useState<string[]>();
  const [isUploadCompleted, setIsUploadCompleted] = useState(true);
  return (
    <Form>
      {" "}
      {status !== "Archived" ? (
        <>
          <Form.Group className="mb-3" controlId="formGroupName">
            <Form.Label>
              Current Status: <b>{status || "Active"}</b>
            </Form.Label>
            <br />

            <Form.Label>Action</Form.Label>
            <Form.Select
              defaultValue={status}
              className="form-control-md"
              value={action}
              onChange={(e) => {
                setAction(e.target.value);
              }}>
              <option value="">Select Action</option>
              <option value="Disabled">Disable</option>
              <option value="Archived">Archive</option>
              <option value="Active">Active</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Reason</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="">
            <Form.Label>Attach File (Optional)</Form.Label>
            <ActionFileUpload
              files={files}
              setFiles={setFiles}
              setFilesUrl={setFilesUrl}
              filesUrl={filesUrl}
              isUploadCompleted={isUploadCompleted}
              setIsUploadCompleted={setIsUploadCompleted}
            />
          </Form.Group>

          <Button
            variant="primary"
            type="button"
            disabled={
              !reason ||
              !isUploadCompleted ||
              !action ||
              loading ||
              status === action
            }
            onClick={(e) => {
              // e.preventDefault();
              confirmAlert({
                customUI: ({ onClose }) => {
                  return (
                    <div
                      className="react-confirm-alert-body"
                      style={{ zIndex: 999999999999999 }}>
                      <p>
                        Are you sure you want to{" "}
                        {(action === "Archived" && "archive") ||
                          (action === "Disabled" && "disable") ||
                          (action === "Active" && "activate")}{" "}
                        this user and the relevant SPACE?
                      </p>
                      <div
                        style={{ width: "100%" }}
                        className="d-flex justify-content-end">
                        <Button
                          style={{ marginRight: "4px" }}
                          onClick={() => {
                            onClose();
                            setLoading(true);
                            updateStatus({
                              refetchQueries: [
                                {
                                  query: QUERY.USERS.GET_USER,
                                  variables: { id: userId },
                                },
                                {
                                  query: QUERY.USERS.GET_ACTIVITY_LOG,
                                  variables: { userId: userId, page: 1 },
                                },
                              ],
                              variables: {
                                id: userId,
                                status: action,
                                reason: reason,
                                files: filesUrl,
                              },
                            })
                              .then(() => {
                                toast.success("Status updated successfully");
                                setReason("");
                                setFilesUrl([]);
                                setFiles([]);
                                setLoading(false);
                              })
                              .catch(() => {
                                toast.error("Something went wrong!");
                                setLoading(false);
                              });
                          }}>
                          Yes
                        </Button>{" "}
                        <Button
                          variant="outline-primary"
                          onClick={() => onClose()}>
                          No
                        </Button>
                      </div>
                    </div>
                  );
                },
              });
            }}>
            {!loading ? (
              "Submit"
            ) : (
              <div className="d-flex align-items-center">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
                <div style={{ marginLeft: "8px" }}>
                  {" "}
                  {loading ? "Submitting" : "Uploading"}
                </div>
              </div>
            )}
          </Button>
        </>
      ) : (
        <Form.Group className="mb-3" controlId="formGroupName">
          <Form.Label>
            Current Status: <b>{"Archived"}</b>
          </Form.Label>
        </Form.Group>
      )}
    </Form>
  );
};

export default ActionForm;
